import React, { FocusEventHandler, ReactNode } from "react";
import { FormControl, InputLabel, Select, SelectChangeEvent, SxProps } from "@mui/material";

type LabeledSelectProps = {
  label: string;
  value?: string;
  onChange: (event: SelectChangeEvent) => void;
  children: Array<ReactNode>;
  disabled?: boolean;
  onFocus?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  fullWidth?: boolean;
  defaultValue?: string;
  sx?: SxProps;
};

export default function LabeledSelect({
  label,
  value,
  onChange,
  children,
  disabled,
  onFocus,
  onBlur,
  defaultValue,
  fullWidth = true,
  sx = {},
}: LabeledSelectProps) {
  return (
    <FormControl fullWidth={fullWidth} sx={sx}>
      <InputLabel id="select-label">{label}</InputLabel>
      <Select
        label={label}
        labelId="select-label"
        value={value}
        onChange={onChange}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        defaultValue={defaultValue}
      >
        {children}
      </Select>
    </FormControl>
  );
}
